import { render, staticRenderFns } from "./pwa_action_groups.vue?vue&type=template&id=e8a182a8&scoped=true&"
import script from "./pwa_action_groups.vue?vue&type=script&lang=js&"
export * from "./pwa_action_groups.vue?vue&type=script&lang=js&"
import style0 from "./pwa_action_groups.vue?vue&type=style&index=0&id=e8a182a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a182a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8a182a8')) {
      api.createRecord('e8a182a8', component.options)
    } else {
      api.reload('e8a182a8', component.options)
    }
    module.hot.accept("./pwa_action_groups.vue?vue&type=template&id=e8a182a8&scoped=true&", function () {
      api.rerender('e8a182a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/actions/list/pwa_action_groups.vue"
export default component.exports